import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";

import Home from "@/pages/Home";
import Mandirs from "@/pages/Mandirs";
import MandirDetails from "@/pages/MandirDetails";
import DivineBless from "@/pages/DivineBless";
import BookingFlow from "@/pages/BookingFlow";
import MyBookings from "@/pages/MyBookings";
import Account from "@/pages/Account";
import VedicServices from "@/pages/VedicServices";
import Panchang from "@/pages/Panchang";
import PanchangDetail from "@/pages/PanchangDetail";
import KundliDosha from "@/pages/KundliDosha";
import MyReports from "@/pages/MyReports";
import Matchmaking from "@/pages/Matchmaking";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import About from "@/pages/About";
import Legal from "@/pages/Legal";
import DynamicPage from "@/pages/DynamicPage";
import PurohitPortal from "@/pages/PurohitPortal";
import AdminDashboard from "@/pages/AdminDashboard";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mandirs" element={<Mandirs />} />
        <Route path="/mandirs/:id" element={<MandirDetails />} />
        <Route path="/divine-bless" element={<DivineBless />} />
        <Route path="/book/:type" element={<ProtectedRoute><BookingFlow /></ProtectedRoute>} />
        <Route path="/my-bookings" element={<ProtectedRoute><MyBookings /></ProtectedRoute>} />
        <Route path="/my-reports" element={<ProtectedRoute><MyReports /></ProtectedRoute>} />
        <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
        <Route path="/vedic-services" element={<VedicServices />} />
        <Route path="/vedic-services/panchang" element={<Panchang />} />
        <Route path="/vedic-services/panchang/:kind/:id" element={<PanchangDetail />} />
        <Route path="/vedic-services/kundli" element={<KundliDosha />} />
        <Route path="/vedic-services/dosha" element={<KundliDosha />} />
        <Route path="/vedic-services/matchmaking" element={<Matchmaking />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/legal/:doc" element={<Legal />} />
        <Route path="/p/:slug" element={<DynamicPage />} />
        <Route path="/purohit" element={<ProtectedRoute><PurohitPortal /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="bottom-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
